/**
 * lib-components
 *
 * Adapptio library to help creating components.
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { useContext } from "react";
import { TranslationContext } from "./TranslationContext";

export type TTranslateHookFn = (
	domain: string,
	term: string,
	vars?: { [K: string]: string | number | boolean },
	fallbackValue?: string
) => string;

/**
 * Hook that returns a translation function
 */
export function useTranslate(): TTranslateHookFn {
	const tCtx = useContext(TranslationContext);

	return (
		domain: string,
		term: string,
		vars?: { [K: string]: string | number | boolean },
		fallbackValue?: string
	) => {
		if (tCtx.translate) {
			return tCtx.translate(domain, term, vars, fallbackValue);
		} else {
			console.warn("No translate function is available.");
			return term;
		}
	};
}
